import React from 'react';
import {_GPY,__GPYPost } from '../../env.js'
import $ from "jquery";


class GameScoreBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        NAME: "SoccerFootball",
        defaultValuesLoaded : false,
        components : {},
        dataHooks : {},
        toggleButtons: {},
        currentGame: {id:-1},
        gamesIsLoaded: false,
        games : {},
        selectedPlayers : {},
        doStore:false,

        overlayConfig : {},
        overlayConfigIsLoaded: false,

        dataStore  : {},
        defaultDataStore:{},

        displayWidth : this.props.displayWidth!==undefined?this.props.displayWidth: window.innerWidth/4,

        currentPeriodIndex:0,
        currentPeriodName:"",
        currentRoleSetup: {},
        crawlRightToLeft:true,
    };
  }

  getCurrentGuestScore() {
    return -1;
  }
  getCurrentHomeScore() {
    return -1;
  }

  keyDownListener = (e) => {
     if(e.target.getAttribute("ignorekeys")!=="true") {
        var tbs = this.state.toggleButtons;
        Object.keys(tbs).forEach((key, i) => {
            tbs[key].onKeyDown(e);
        });
        /*
        if ( e.key!==" " && !isNaN(e.key) ) {
               if(this.state.components.Hockey_teamlist_home_player!==undefined) this.state.components.Hockey_teamlist_home_player.appendPlayerHighlight(e.key);
               if(this.state.components.Hockey_teamlist_guest_player!==undefined) this.state.components.Hockey_teamlist_guest_player.appendPlayerHighlight(e.key);
        }
        */
     }
    };

  	onReSize = (e)=>{
  		this.setState({displayWidth : this.props.displayWidth!==undefined?this.props.displayWidth: window.innerWidth/4})
  	};

    componentDidMount() {
      this.autoStore = setInterval(() => {
        this.autoDataStore()
      }, (10*1000));
      document.addEventListener("keydown", this.keyDownListener);
  		window.addEventListener('resize', this.onReSize);
  	}

  	async componentWillUnmount(){
      clearInterval(this.autoStore);
      document.removeEventListener("keydown",this.keyDownListener);
  		window.removeEventListener( 'resize',this.onReSize);
  	}

    toggleButton(state) {
      if(this.state.components[state]!==undefined ) {
          if(this.state.components[state].isActive()){
            this.state.components[state].onDeactivate();
          } else {
            this.state.components[state].onActivate();
          }
      }
    }

    getGameMapByTournament(tournament,games) {
        var seen = [];
        tournament._data.games.forEach((p, i) => {
          p.forEach((v, i) => {
              if (!seen.includes(v)) {
                seen.push(v);
              }
          });
        });
        var res = {};
        games.forEach((g, i) => {
          if( seen.includes(g.id) ) {
            res[g.id] = g;
          }
        });
        return res;
    }

    setUserRole (role,id) {
      var rs = this.state.currentRoleSetup;
      rs[role] = id;
      this.setState({rs});
    }

    getRoleSetup (role) {
      return this.state.currentRoleSetup[role];
    }

    autoDataStore() {
  		if(this.state.doStore) {
  			this.setState({doStore:false},()=>{
              this.storeData();
  			})
  		}
  	}

    getCurrentMainTime() {
      var clock = this.getMainClock();
      if(clock!==undefined) {
        return clock.getSecond();
      } else {
        return 0;
      }
    }

    getCurrentGameId() {
        return this.state.currentGame.id;
    }

  markToStore() {
    this.setState({doStore:true});
  }

  storeData(){
        var data = this.state.dataStore;
        Object.keys(this.state.dataHooks).forEach((item, i) => {
            this.state.dataHooks[item].storeGameData(data);
        });
			var json = JSON.stringify(this.state.dataStore);
			__GPYPost("storeGameData",{gameId:this.state.currentGame.id,dataKey:"DATA_STORE",dataValue:json});
	}

  getName(){
    return this.state.NAME;
  }

  getGPYState(name) {
    var s = this.state
    s.NAME = name;
    return s;
  }

  getComponent(stateName) {
    return this.state.components[stateName];
  }

  setGameType(f){
     this.props.setGameType(f);
  }

  getMainClock() {
 		if(this.state.components[this.state.NAME+'_gameclock']!==undefined) {
			return this.state.components[this.state.NAME+'_gameclock'];
		}
	}

  adjustTimers(millis,callback) {
				if(this.state.components[this.state.NAME+'_gameclock']!==undefined) this.state.components[this.state.NAME+'_gameclock'].changeOffset(millis,callback);
				for(var a in this.state.mainClockDependenciesClocks) {
					var i = this.state.mainClockDependenciesClocks[a]
					if( this.state.components[i.clock]!==undefined && !this.state.components[i.clock].isActive()) {
								this.state.components[i.clock].changeOffset(millis,callback);
					}
				}
	}

  togglePlay(method) {
		if(method===undefined) {
			method = 	this.state.components[this.state.NAME+'_gameclock']!==undefined && this.state.components[this.state.NAME+'_gameclock'].isActive()?"stop":"start";
		}
    var a,i;
		if(method==="start"){
			for( a in this.state.mainClockDependenciesClocks) {
				 i = this.state.mainClockDependenciesClocks[a]
				if(i.button !== undefined && this.state.components[i.button] !== undefined && this.state.components[i.button].isActive() ) {
							this.state.components[i.button].resume();
				}
			}
			for( a in this.state.mainClockDependenciesClocks) {
				 i = this.state.mainClockDependenciesClocks[a]
				if( this.state.components[i.clock]!==undefined && i.button !== undefined && this.state.components[i.button] !== undefined && this.state.components[i.button].isActive()) {
							this.onPlayTime(i.clock,"start");
				}
			}
			this.onPlayTime(this.state.NAME+"_gameclock","start");
		}	else {
			for( a in this.state.mainClockDependenciesClocks) {
				 i = this.state.mainClockDependenciesClocks[a]
				if(i.button !== undefined && this.state.components[i.button] !== undefined && this.state.components[i.button].isActive() ) {
							this.state.components[i.button].pause();
				}
			}
			for( a in this.state.mainClockDependenciesClocks) {
				 i = this.state.mainClockDependenciesClocks[a]
				console.log("STOP:",i);
				if( this.state.components[i.clock]!==undefined && this.state.components[i.button] !== undefined && this.state.components[i.button].isActive()) {
							this.onPlayTime(i.clock,"stop");
				}
			}
		  this.onPlayTime(this.state.NAME+"_gameclock","stop");
		}
	}


  /* ===========================================================================
  *  GAMES
  */
  onSelectGame(pk,reset) {
     pk = parseInt(pk,10);
     var g = undefined;
     this.state.games.Games.Game.forEach((t) => {
         if(t.id === pk) {
           g = t;
         }
     });
     if(g === undefined) {
         this.state.games.Games.GuestGame.forEach((t) => {
           if(t.id === pk) {
             g = t;
           }
         });
     }

     if(reset!==undefined) {
       reset();
     }

     Object.keys(this.state.components).forEach(key => {
         var c = this.state.components[key];
         if(c !== undefined && c['onDeactivate'] !== undefined){
           if(c['isActive']()) {
              c['onDeactivate']();
           }
         }
     });

     $('#gametype_'+this.state.NAME+'_scoreboard_games').collapse('hide');
     if(g !== undefined) {

       var teamMap = {};
       g.teams.Team.forEach((t) => {
           teamMap[t.vsRole] = t;
       });
       g.teamMap = teamMap;

       g.players.Player.forEach( (p) => {
         if(p.vsUiState === undefined || p.vsUiState === '') {
             p.vsUiState = '{"player":false, "substitue":false, "sortIndex" : 0 }';
         }
         p._config = JSON.parse(p.vsUiState);
       });

       g.players.Player.sort(_GPY.playerSorter);


       this.setState({currentGame: g}, ()=>{
         if(this.state.components['gamelog'] !== undefined && this.state.components['gamelog'] !== undefined){
           this.state.components['gamelog'].init();
         }
       });


       var ds = JSON.parse(JSON.stringify(this.state.defaultDataStore));

       if(g.gameData !== undefined && g.gameData.values !== undefined) {
         for (var key in g.gameData.values) {
           if(key === "DATA_STORE") {
                var _ds = JSON.parse(g.gameData.values[key]);
                for(var k in _ds) {
                  ds[k] = _ds[k];
                }
           }
//         if (g.gameData.values.hasOwnProperty(key)) {
//         }
        }
       }
       console.log("DATA_STORE",ds);
       this.setState({dataStore:ds},()=>{
         Object.keys(this.state.dataHooks).forEach((item, i) => {
             this.state.dataHooks[item].loadGameData(ds);
         });
       });
       __GPYPost('setUIState',{selectedGamePk: g.id});
     }
   }


   getGames(obj) {
       if(obj === undefined) {
         obj = {};
       }
       __GPYPost('getGames',obj,(res) => {
          res.Games.Game.forEach((t) => {
            if(t.teams.Team === undefined || t.teams.Team.length === 0) {
              t.teams.Team = [{id:-1,vsRole:"HOME_TEAM"},{id:-1,vsRole:"GUEST_TEAM"}];
            }
          });
          this.setState({
           gamesIsLoaded: true,
           games: res,
          });
         if(_GPY.uiStates.selectedGamePk !== undefined) {
           this.onSelectGame( _GPY.uiStates.selectedGamePk );
         } else {
           $('#gametype_'+this.state.NAME+'_scoreboard_games').collapse('show');
         }
       },(err)=>{
       });
   }

   getPlayerById(id) {
     if(id===undefined) return {};
     else {
       if(this.state.currentGame!==undefined) {
         var players = this.state.currentGame.players.Player;
         for(var i = 0;i<players.length;i++) {
           var p = players[i];
           if(id===p.id) {
             console.log("Player",p);
             return p;
           }
         }
       }  else {
         return {};
       }
     }
   }

   getHomeOrGuestPlayer() {
       if(this.state.selectedPlayers['HOME_TEAM_PLAYER']!== undefined && this.state.selectedPlayers['GUEST_TEAM_PLAYER'] === undefined) {
         return this.state.selectedPlayers['HOME_TEAM_PLAYER'];
       }
       if(this.state.selectedPlayers['GUEST_TEAM_PLAYER']!== undefined && this.state.selectedPlayers['HOME_TEAM_PLAYER'] === undefined) {
         return this.state.selectedPlayers['GUEST_TEAM_PLAYER'];
       }
       return {id:-1};
    }

    getHomeOrGuestSubstitutionPlayer(){
        if(this.state.selectedPlayers['HOME_TEAM_SUBSTITUE']!== undefined && this.state.selectedPlayers['GUEST_TEAM_SUBSTITUE'] === undefined) {
        return this.state.selectedPlayers['HOME_TEAM_SUBSTITUE'];
       }
      if(this.state.selectedPlayers['GUEST_TEAM_SUBSTITUE']!== undefined && this.state.selectedPlayers['HOME_TEAM_SUBSTITUE'] === undefined) {
        return this.state.selectedPlayers['GUEST_TEAM_SUBSTITUE'];
      }
      return {id:-1};
    }

    playerArrayByRole(roles) {
      var res = [];
      var role = roles.split(',');
      for( var i=0;i<role.length;i++) {
        if( this.state.selectedPlayers[role[i]] !== undefined) {
          res.push(this.state.selectedPlayers[role[i]]);
        }
      }
      return res;
    }

    playerCountByRole(roles) {
        var res = 0;
        var role = roles.split(',');
        for( var i=0;i<role.length;i++) {
          if( this.state.selectedPlayers[role[i]] !== undefined) {
            res++;
          }
        }
        return res;
    }

    getTeamByCoach(p) {
      if(p.vsRole === 'HOME_TEAM_COACH') {
         return this.state.currentGame.teamMap.HOME_TEAM;
      } else {
        return this.state.currentGame.teamMap.GUEST_TEAM;
      }
    }

  	 getTeamByPlayer(p) {
  		 if(p.vsRole === 'HOME_TEAM_PLAYER' || p.vsRole === 'HOME_TEAM_SUBSTITUE') {
  			 	return this.state.currentGame.teamMap.HOME_TEAM;
  		 } else {
  			 return this.state.currentGame.teamMap.GUEST_TEAM;
  		 }
  	 }

      unselectPlayertLists() {
        if(this.state.components[this.state.NAME+'_teamlist_home_player']!==undefined) this.state.components[this.state.NAME+'_teamlist_home_player'].forceUnselectPlayer();
  			if(this.state.components[this.state.NAME+'_teamlist_guest_player']!==undefined) this.state.components[this.state.NAME+'_teamlist_guest_player'].forceUnselectPlayer();
  			if(this.state.components[this.state.NAME+'_teamlist_home_substitue']!==undefined) this.state.components[this.state.NAME+'_teamlist_home_substitue'].forceUnselectPlayer();
  			if(this.state.components[this.state.NAME+'_teamlist_guest_substitue']!==undefined) this.state.components[this.state.NAME+'_teamlist_guest_substitue'].forceUnselectPlayer();
      }
  		refreshPlayerLists() {
        if(this.state.components[this.state.NAME+'_teamlist_home_player']!==undefined) this.state.components[this.state.NAME+'_teamlist_home_player'].refresh();
  			if(this.state.components[this.state.NAME+'_teamlist_guest_player']!==undefined) this.state.components[this.state.NAME+'_teamlist_guest_player'].refresh();
  			if(this.state.components[this.state.NAME+'_teamlist_home_substitue']!==undefined) this.state.components[this.state.NAME+'_teamlist_home_substitue'].refresh();
  			if(this.state.components[this.state.NAME+'_teamlist_guest_substitue']!==undefined) this.state.components[this.state.NAME+'_teamlist_guest_substitue'].refresh();
  		}
  		selectPlayerById(id) {
        if(this.state.components[this.state.NAME+'_teamlist_home_player']!==undefined) this.state.components[this.state.NAME+'_teamlist_home_player'].selectPlayerById(id);
  			if(this.state.components[this.state.NAME+'_teamlist_guest_player']!==undefined) this.state.components[this.state.NAME+'_teamlist_guest_player'].selectPlayerById(id);
  			if(this.state.components[this.state.NAME+'_teamlist_home_substitue']!==undefined) this.state.components[this.state.NAME+'_teamlist_home_substitue'].selectPlayerById(id);
  			if(this.state.components[this.state.NAME+'_teamlist_guest_substitue']!==undefined) this.state.components[this.state.NAME+'_teamlist_guest_substitue'].selectPlayerById(id);
  		}

      onSelectPlayer(player) {
        var s = this.state;
        s.selectedPlayers[player.vsRole] = player;
        this.setState({selectedPlayers : s.selectedPlayers});
        this.doChangeValue(player,undefined,"onSelectPlayer");
        console.log(s);
      }

      onDeselectPlayer(role,player) {
        if(player!==undefined) {
          this.doChangeValue(player,undefined,"onDeselectPlayer");
        }
        var state = this.state;
        delete state.selectedPlayers[role];
        this.setState(state);
      }

      registerComponent(name,c) {
  			var comps = this.state.components;
        comps[name] = c;
        this.setState({components:comps});
  		}

      registerHooks(name,c) {
        var comps = this.state.dataHooks;
        comps[name] = c;
        this.setState({dataHooks:comps});
      }


      registerButton(name,c) {
        var tb = this.state.toggleButtons;
        if(this.state.config !== undefined && this.state.config[name] !== undefined){
            c.setConfig(this.state.config[name]);
        }
        tb[name] = c;
        this.setState({toggleButtons:tb});
      }

      loadUserConfig(prefix = "buttons_",callback = ()=>{}) {
        console.log("loadUserButtonConfig");
        return new Promise(resolve => {
            __GPYPost('getUserConfig',{name: (prefix+this.state.NAME)},(res) => {
                  var conf = JSON.parse(res.UserConfig.data);
                  this.setState({config:conf},()=>{
                    console.log("loadUserButtonConfig:RESOVE",conf);
                    var tbs = this.state.toggleButtons;
                    if(tbs!==undefined){
                        Object.keys(tbs).forEach((key, i) => {
                          tbs[key].setConfig(conf[key]);
                        });
                    }
                    callback();
                    resolve(true);
                  });

            },(fail) => {resolve(false);} );
        });
      }


      storeUserConfig(prefix = "buttons_",conf = {},callback = ()=>{}) {
        console.log("CONFIG",conf);
          __GPYPost('storeUserConfig',{name:prefix+this.state.NAME, data : JSON.stringify(conf)}, (r)=>callback(r));
      }

      onPlayTime(stateName,method){
        var c = this.state.components[stateName];
        if(c !== undefined && c[method] !== undefined) {
          c[method](()=>{
            this.forceUpdate();
          });
        }
      }

      setGameTime(stateName,s) {
         this.doChangeValue({
           offset:s,
         },stateName);
      }

      setTimeTo(stateName,s) {
        if(this.state.components[stateName] !== undefined){
          this.state.components[stateName].setTimeTo(s);
        }
      }

      startTimeAt(stateName,s) {
        if(this.state.components[stateName] !== undefined){
          this.state.components[stateName].startAt(s);
        }
      }

      storeOnChangeFormData(name,e) {
        if(e!==undefined) {
          		 var s = {};
  			       s[name] = e.target.value;
  			       this.setState(s);
        }
  		}

      doCall(name,obj,k) {
        if(k !== undefined){
          var c = this.state.components[k];
          if(c !== undefined && c[name] !== undefined){
            c[name](obj);
          }
          return;
        }
        Object.keys(this.state.components).forEach(key => {
            var c = this.state.components[key];
            if(c !== undefined && c[name] !== undefined){
              c[name](obj);
            }
        });
      }

      doChangeValue(obj,k,method) {
  			if(k !== undefined) {
  				var c = this.state.components[k];
  				if(method!== undefined  && c[method] !== undefined) {
  					c[method](obj);
  				} else if(c !== undefined && c.onChangeValue !== undefined){
  						c.onChangeValue(obj);
  				}
  				return;
  		 	}

  			Object.keys(this.state.components).forEach(key => {
  					var c = this.state.components[key];
  					if(method!== undefined  && c[method] !== undefined) {
  						c[method](obj);
  					} else if(c !== undefined && c.onChangeValue !== undefined){
  							c.onChangeValue(obj);
  					}
  			});
  		}

      reset() {
        Object.keys(this.state.components).forEach(key => {
            var c = this.state.components[key];
            if(c !== undefined && c['onDeactivate'] !== undefined){
              if(c['isActive']()) {
                 c['onDeactivate']();
              }
            }
        });
        if(this.state.components['gamelog'] !== undefined && this.state.components['gamelog'] !== undefined){
          this.state.components['gamelog'].init();
        }
      }

     getGamesStates() {
       __GPYPost('getGameState',{gameState:this.props.stateName},(res) => {
         var allStates = res.GameState.values;

         Object.keys(allStates).forEach(key => {
           if(allStates[key].startsWith('{')){
             allStates[key] = JSON.parse(allStates[key]);
           }
         });
         allStates["defaultValuesLoaded"] = true;
         this.setState( allStates );
       });
     }



    getDefaultValues(clazz) {
      __GPYPost('getGameState',{gameState:clazz},(res) =>  {
        this.setState({defVal : res.GameState.values});
      });
    }

    onData(key,data) {
      // console.log("onData GameScoreBoard >> ",key,data);
      var tmp = this.state.components[key];
        /*
        if(tmp === undefined && key.endsWith("_timeout")) {
          tmp = this.state.components[key.replace("_timeout","")];
        }*/
      if(tmp !== undefined && tmp.onData !== undefined) {
        tmp.onData(key,data);
      }
    }
}

export default GameScoreBoard;
